//获取公司信息
import { useState, useEffect } from 'react'
import { getCompanyListAPI } from '@/apis/company'

function useCompanyList() {
    const [companyList, setCompanyList] = useState([])

    const fetchList = async () => {
        try {
            const res = await getCompanyListAPI()
            setCompanyList(res.data)
        } catch (error) {
            console.error("Failed to fetch company list:", error)
        }
    }

    useEffect(() => { fetchList() }, [])

    return { companyList, refresh: fetchList }
}

export { useCompanyList } 